export const MEETING_TYPES = {
    "Live Event": "liveEvent",
    "Live CPE": "liveCPE",
    "On Demand": "onDemand",
    "On Demand CPE": "onDemandCPE",
    "Self-Study": "selfStudy"
};

export const MEETING_TYPES_INTS = {
    liveEvent: 1,
    onDemand: 2,
    liveCPE: 3,
    onDemandCPE: 4,
    selfStudy: 5
};
